import { Link } from 'react-router-dom';
import PieveWordmark from '@/components/surfaces/PieveWordmark.jsx';
import ConnectedActionsIllustration from './ConnectedActionsIllustration.jsx';
import '../styles/auth.css';

/**
 * The frame of every sign-in screen: the form on the left, and on wide screens a Deep Teal panel
 * that shows what Pieve does (one request, several actions in the person's apps).
 */
const AuthLayout = ({ title, description, children, footer }) => {
  return (
    <div className="auth-layout">
      <main className="auth-layout__main">
        <Link to="/sign-in" className="auth-layout__brand" aria-label="Pieve, sign in">
          <PieveWordmark height={26} />
        </Link>
        <div className="auth-layout__form">
          <h1 className="auth-layout__title">{title}</h1>
          {description && <p className="auth-layout__description">{description}</p>}
          {children}
        </div>
        {footer && <div className="auth-layout__footer">{footer}</div>}
      </main>
      <aside className="auth-layout__panel" aria-hidden="true">
        <ConnectedActionsIllustration />
        <div className="auth-layout__panel-copy">
          <p className="auth-layout__panel-title">Tell Pieve. It&apos;s done.</p>
          <p className="auth-layout__panel-text">Pieve works in the apps you connect, shows each step it takes, and asks before anything that needs you.</p>
        </div>
      </aside>
    </div>
  );
};

export default AuthLayout;
